export default {
	text: 'You are using an outdated version of the site.\nUpdate the page.',
	reconnecting: 'Wait, connecting to server',
	btn: 'Update',
}
